// extracted by mini-css-extract-plugin
export default {"wrapper":"full-ui_wrapper__gwR92","mainColumn":"full-ui_mainColumn__dDPUT"};